const { toInt, toString } = require('@/functions/transform');

/**
 * Structure of single Table for Tables collection in TablePlan.
 */
class Table {
    constructor() {
        /**
         * @type {?number}
         */
        this.ID = null;

        /**
         * @type {string}
         */
        this.name = '';

        /**
         * @type {number}
         */
        this.navOrder = 0;

        /**
         * @type {string}
         */
        this.status = '';
    }

    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'tableID'],
                transform: toInt,
            },
            name: toString,
            navOrder: toInt,
            status: toString,
        };
    }
}

module.exports = Table;
